import { isReturnFlightOptions } from '@shared/v2/utils/types/flightOptions';

import { ResponseWithFlightOptions } from '../../types';

export const mergeReturnJourneys = (data: ResponseWithFlightOptions[]) => {
  const returnJourneys = data.flatMap(({ flightOptions }) => {
    if (isReturnFlightOptions(flightOptions)) {
      return flightOptions.returnJourneys;
    }

    return [];
  });

  return { returnJourneys };
};
